import React from "react";

// Blocs réutilisés par les tableaux de bord enseignant et étudiant.

export const StatCard = ({ title, value, icon, color = "primary", subtitle, col = "col-xl-3 col-sm-6" }) => (
  <div className={`${col} mb-3`}>
    <div className="card h-100">
      <div className="card-body d-flex align-items-center justify-content-between">
        <div>
          <p className="mb-1 text-muted">{title}</p>
          <h3 className="mb-0">{value ?? "-"}</h3>
          {subtitle && <small className="text-muted">{subtitle}</small>}
        </div>
        <span className={`avatar avatar-lg bg-${color}-transparent rounded-circle d-flex align-items-center justify-content-center`}>
          <i className={`${icon} text-${color} fs-24`}></i>
        </span>
      </div>
    </div>
  </div>
);

export const Spinner = ({ label }) => (
  <div className="page-wrapper">
    <div className="content text-center py-5">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">{label}</span>
      </div>
    </div>
  </div>
);

export const Panel = ({ title, action, children, col = "col-lg-6" }) => (
  <div className={`${col} mb-3`}>
    <div className="card h-100">
      <div className="card-header d-flex align-items-center justify-content-between">
        <h5 className="mb-0">{title}</h5>
        {action}
      </div>
      <div className="card-body p-0">{children}</div>
    </div>
  </div>
);

export const Empty = ({ text }) => <p className="text-muted text-center py-4 mb-0">{text}</p>;

export const scoreBadge = (passRate) => (
  passRate === null || passRate === undefined
    ? "-"
    : <span className={`badge badge-soft-${passRate >= 50 ? "success" : "danger"}`}>{passRate}%</span>
);
